import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class TelegramService {

    constructor(private api: ApiService) {}

    getStatus() {
        return this.api.get(this.api.path + '/telegram/status');
    }

    getLink() {
        return this.api.get(this.api.path + '/telegram/link');
    }

    disconnect() {
        return this.api.delete(this.api.path + '/telegram/disconnect');
    }

    disconnectReseller(id: any) {
        return this.api.delete('admin/telegram/reseller/' + id + '/disconnect');
    }
}
